





























































































import { Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { isLogin, getSchema,getTaskExp,getTaskExpColumns} from '@/global/utils';
import { DOMAIN } from '@/global/constants';
import { getValidate,getToken,taskSign } from '@/api/task/crowd';
import { getTask, valGuarantee } from '@/api/task/team';
import moment from 'moment';
const Guarantee = () => import('@/components/guarantee.vue');
const RealName = () => import('@/components/realName.vue');

@Component({
  components: {
    Guarantee,
    RealName,
  },
})
export default class TeamDetailHeader extends Vue {
  @Prop() private task!: object;
  @Prop() private currentPage!: string;
  private keyword: string = process.env.VUE_APP_KEYWORD;
  // 显示数据模型
  private taskSchema: any;
  // 保底计划弹窗显示
  private guaranteeShow: boolean = false;
  //任务显示经验值
  private taskExp: any;
  //任务详情页经验值title
  private columns: any;
  // 实名认证 modal
  private realNameShow: boolean = false;
  // 实名认证信息
  private realNameMsg: string[] = [
    '该实名信息只用于平台任务及提现的法律凭证，不做其他用途',
    `一个身份证只可绑定一个${this.keyword}ID`,
    '每日认证超过5次当天将不可再认证，请认真核实后进行提交',
  ];
  // 龙猫协议url 名称 modal check
  private agreementUrl: string = '';
  private agreementName: string = `${this.keyword}协议`;
  private proVisible: boolean = false;
  private checked: boolean = false;
  private stageType = Object.freeze({
    CHECK_STAGE: 1,
    REDO_STAGE: 2,
  });
  private modualTaskType = Object.freeze({
    1: 51,
    2: 52,
    3: 53,
    4: 54,
    5: 55,
    6: 56,
    7: 57,
    9: 52,
    10: 55,
  });
  get userInfo() {
    return this.$store.state.userInfo;
  }
  get myExp(){
    return this.$store.state.myExp;
  }
  @Watch('myExp')
  private userIdChange(to: any, from: any) {
    if(to){
      const list=getTaskExp(this.task,this);
      list.forEach((item, index) => {
        Vue.set(this.taskExp, index, item)
      })
      // this.taskExp = getTaskExp(this.task,this);
    }
  }
  private created() {
    this.taskSchema = getSchema(this.task);
    // 价格只对团队长可见
    // if(!this.userInfo.offline_leader){
    //   this.taskSchema.pop()
    // }
    if(this.userInfo && this.userInfo.team_general_user){
      this.taskSchema.pop()
    }
    this.taskExp = getTaskExp(this.task,this);
    this.columns = getTaskExpColumns();
  }
  // 领取任务
  private async handlerReceiveTask() {
    if (!isLogin(this)) {
      return;
    }
    if (!this.userInfo.offline_leader) {
      this.$Modal.confirm({
        title: '领取失败',
        content: '您还未加入任何团队，点击下方按钮，查看如何加入公会',
        okText: '加入公会攻略',
        cancelText: '取消',
        onOk: () => {
           window.open("http://help.longmaosoft.com/forum.php?mod=viewthread&tid=474&extra=", "_blank")
        },
      });
    } else {
      const resp: any = await getTask({ id: (this.task as any).id });
      if (resp.code == '200') {
        this.$Message.success('领取成功');
        this.$emit('detailReload');
      } else {
        this.$Notice.error({
          title: '提示',
          desc: resp.message || '未知错误！',
        });
        this.$emit('detailReload');
      }
    }
  }
  // 打开保底计划弹窗
  private async showGuarantee() {
    const resp: any = await valGuarantee({ mid: (this.task as any).id });
    if (resp.message.code == '500') {
      this.$Notice.error({
        title: '提示',
        desc: resp.message.message,
      });
    } else {
      this.guaranteeShow = true;
    }
  }
  // 关闭保底计划弹窗
  private closeGuarantee() {
    this.guaranteeShow = false;
  }
  // 审核（只有新审核模块有此按钮）
  private handlerExamine() {
    const task: any = this.task;
    this.$router.push({
      name: 'examine',
      params: { page:'team', id: task.id },
    });
  }
  // 优先审核
  private handlerCheckFirst() {
    const task = this.task as any;
    this.$router.push({
      name: 'checkfirst',
      params: { id: task.id, page: 'team' },
    });
  }
  // 打开实名认证弹窗
  private openRealName() {
    this.realNameShow = true;
  }
  // 关闭实名认证弹窗
  private closeRealName() {
    this.realNameShow = false;
  }
  // 做题
  private async handlerStartLib(type) {
    if (!isLogin(this)) {
      return;
    }

    if(type == 'redo'){
      this.openEditor(this.stageType.REDO_STAGE, null);
    }else{
      this.openEditor(null, null);
    }

    // const task: any = this.task;
    // // 是否有做题权限: 未实名认证或未签署协议
    // const res: any = await getValidate({ id: task.id });
    // if (res.code === '510004') {
    //   this.realNameShow = true;
    // } else if (res.code === '510006') {
    //   this.agreementUrl = task.agreementInfo ? task.agreementInfo.url : '';
    //   this.agreementName = task.agreementInfo
    //     ? task.agreementInfagreement_name
    //     : '龙猫协议';
    //   this.proVisible = true;
    //   this.checked = false;
    // } else if (res.code === '200') {
    //   console.log('已经实名认证但不用签署协议或实名认证并签署协议');
    //   if (task.type == 7) {
    //     const resp: any = await getToken({ type: task.outside_type });
    //     if (resp.code === '200') {
    //       this.openEditor(null, resp);
    //     } else {
    //       this.$Modal.error({
    //         title: '无法做题',
    //         content: resp.message,
    //       });
    //     }
    //   } else {
    //     if (type === 'redo') {
    //       this.openEditor(this.stageType.REDO_STAGE, null);
    //     } else {
    //       this.openEditor(null, null);
    //     }
    //   }
    // } else {
    //   this.$Modal.error({
    //     title: '无法做题',
    //     content: res.message,
    //   });
    // }
  }
  // 做题 跳转页面
  private openEditor(stage, token) {
    // let url = `${DOMAIN}/tools/`;

    // ccb跳转配置

    // let url = window.location.host + '/ecpweb/page/aiom/mark/'
    let page = 'http://'+ window.location.host + '/ecpweb/page/aiom/task_platform/taskjump.jsp'
    let url = ''
    const task: any = this.task;
    console.log('go task: ',task)

    const loginToken = (window as any).loginToken

    if (task.type === 7) {
      if (task.outside_url) {
        // url += `platform.html?url=1&token=${token.result.token}`;
        url += `platform.html?url=1&token=${loginToken}`;
      }
    } else {
      if (/^sketch(-.+)?$/.test(task.from)) {
        const parts = task.from.split('-');
        url += `${parts.length > 1 ? parts[1] : 'markPage'}.html`;
      } else if (task.from) {
        url += task.from + '.html';
      } else {
        url += 'markPage.html';
      }
      url += `?type=${this.modualTaskType[task.type]}&id=${task.id}&version=2`;
      url += !stage ? '' : `&stage=${stage}`;
      url += `&token=${loginToken}`
    }

    window.open(page+'?url='+window.encodeURIComponent(url));
  }
  // 质检（crowd）
  private handlerInspectLibs() {
    if (!isLogin(this)) {
      return;
    }
    const task = this.task as any;
    this.$router.push({
      name: 'inspect',
      params: { page: 'crowd', id: task.id },
    });
  }
  // 协议同意
  private async onProtocolOk() {
    const task: any = this.task as any;
    const res: any = await taskSign({ id: task.id });
    if (res.code === '200') {
      this.$Notice.info({
        title: '任务协议',
        desc: '签署成功!',
      });
      this.proVisible = false;
    } else {
      this.$Notice.info({ title: '提示', desc: res.message || '请求失败' });
    }
  }
  // 协议拒绝
  private onProtocolClose() {
    this.checked = false;
    this.proVisible = false;
    this.agreementUrl = '';
  }
}
